export default __webpack_public_path__ + "static/video-hero-7124b563480caae0a7be81a3020d1838.mp4";